import { breakpoint, Button, DisplayField, Heading, Logo, Text } from "@digitools/honest-ui";
import { CloseIcon } from "@digitools/honest-ui/icons";
import React, { useEffect } from "react";
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import useTranslate from "src/hooks/useTranslate";
import { ViewSubmissionText } from "../../constants/viewSubmissionText";
import useAsDataContext from "../../hooks/useAsDataContext";
import useExperience from "src/hooks/useExperience";
import { TEALIUM_EVENT } from "src/constants/tealiumConstants";
import useTealium from "src/hooks/useTealium";
import ReviewAboutYou from "../review/ReviewAboutYou";
import AccommodationDetails from "../review/AccommodationDetails";
const PrintableBody = styled.div `
  @media (min-width: ${breakpoint.lg}) {
    margin-inline: var(--spacing-xl-8);
  }
  @media print {
    @page {
        size: 300mm 307mm;
        margin-top: 20mm !important;
        margin-bottom: 20mm !important;
        margin-right: -40mm !important;
        margin-left: -40mm !important;
    }
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    button {
        display: none;
    }
  }
`;
// Logo + address, then heading + Print: each pair sits at opposite ends of one row
const SplitRow = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md);
`;
const ViewSubmission = () => {
    const navigate = useNavigate();
    const { t } = useTranslate();
    const { claimantData, accommodationResponse } = useAsDataContext();
    const { experience } = useExperience();
    const { trackView } = useTealium();
    window.scrollTo(0, 0);
    const printPdf = () => {
        window.print();
    };
    useEffect(() => {
        trackView({
            page_l3: TEALIUM_EVENT.EVENT_TYPE.ACCOMMODATION,
            page_l5: 'view submission'
        });
    }, []);
    const routeToConfirmationPage = () => {
        window.scrollTo(0, 0);
        navigate(`/as/${experience.toLowerCase()}/confirmation`);
    };
    const getFullName = () => {
        if (claimantData?.empMiName) {
            return claimantData?.empFirstName + " " + claimantData?.empMiName + " " + claimantData?.empLastName;
        }
        else {
            return claimantData?.empFirstName + " " + claimantData?.empLastName;
        }
    };
    return (<PrintableBody>
            <div className='hui-mb-md' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type='text' label={t(ViewSubmissionText.closeButtonLabel)} icon={<CloseIcon />} onClick={routeToConfirmationPage} data-testid="backButtonTestId"/>
            </div>
            <SplitRow className='hui-mb-xl'>
                <Logo />
                <Text as='p' size='sm' style={{ textAlign: 'right', color: 'var(--color-text-tertiary)' }}>
                    {t(ViewSubmissionText.printPageLfgAddress)}
                </Text>
            </SplitRow>
            <SplitRow className='hui-mb-xl'>
                <Heading as='h1' visualLevel='h2'>{t(ViewSubmissionText.viewSubmissionPageHeading)}</Heading>
                <Button type='primary' label={t(ViewSubmissionText.printLabel)} onClick={printPdf}/>
            </SplitRow>

            <DisplayField title={`${t(ViewSubmissionText.requestIdLabel)}${accommodationResponse?.eventNum ?? ''}`} headingLevel='h2' className='hui-mb-lg' columns={2} fields={[
            { label: t(ViewSubmissionText.nameLabel), value: <span data-private={true}>{getFullName()}</span> },
            { label: t(ViewSubmissionText.todayDateLabel), value: accommodationResponse?.submittedDateTime },
        ]}/>
            <ReviewAboutYou displayButton={false}/>
            <AccommodationDetails displayButton={false}/>
            <Text as='p' size='sm' className='hui-mb-sm' style={{ color: 'var(--color-text-tertiary)' }}>
                {t(ViewSubmissionText.printPageFooterTxt)}
            </Text>
            <Text as='p' size='sm' style={{ color: 'var(--color-text-tertiary)' }}>
                {t(ViewSubmissionText.lcnNo)}
            </Text>
        </PrintableBody>);
};
export default ViewSubmission;
